import { render } from "./BioContact.vue?vue&type=template&id=2c93d72b"
import script from "./BioContact.vue?vue&type=script&lang=js"
export * from "./BioContact.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__